// extracted by mini-css-extract-plugin
export var active = "languages-module--active--EnBgi";
export var link = "languages-module--link--yX1JO";
export var text = "languages-module--text--JQFn+";